import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import AboutMe from './pages/AboutMe';
import FellowshipAspirations from './pages/FellowshipAspirations';
import Research from './pages/Research';
import Services from './pages/Services';
import Contact from './pages/Contact';
import EducationSection from './pages/EducationSection';
import "./css/about-me.css";
import "./css/footer.css";
import "./css/educationsection.css";
import "./css/header.css";
import "./css/styles.css";
import "./css/happy-birthday.css";
// import "./css/contact.css";

function App() {
    const [showCelebrate, setShowCelebrate] = useState(true); // Keeps the animation always on

    return (
        <Router>
            <Header />
            <main>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <HeroSection
                                title="Welcome to My Radiology Page"
                                subtitle="Dr. Amulya Kutikuppala"
                                image="/Profile-removebg-preview.png"
                                showCelebrate={showCelebrate} // Pass the prop down to HeroSection
                            />
                        }
                    />
                    <Route path="/about" element={<AboutMe />} />
                    <Route path="/research" element={<Research />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/resume" element={<EducationSection />} />
                </Routes>
            </main>
            <Footer />
        </Router>
    );
}

export default App;
